module.exports = __webpack_public_path__ + "img/logging.7393df52.png";